import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-rect',
  host: {
    class: 'pulse',
  },
  template: ``,
  styles: [
    `
    :host {
      display: inline-block;
      width: var(--skeleton-rect-width);
      height: var(--skeleton-rect-height);
      background: var(--ion-color-medium) no-repeat;
      border-radius: 4px;
    }
  `,
  ],
})
export class SkeletonRectComponent implements OnInit {
  private readonly _host: ElementRef<HTMLElement> = inject(ElementRef);

  @Input() width: string;
  @Input() height: string;
  @Input() className: string;

  ngOnInit() {
    const host = this._host.nativeElement;

    if (this.className) {
      host.classList.add(this.className);
    }

    host.style.setProperty('--skeleton-rect-width', this.width ?? '100%');
    host.style.setProperty('--skeleton-rect-height', this.height ?? '100%');
  }
}
